module.exports = __webpack_public_path__ + "static/aviral_image-69b6a734acbbefc3f4a980043ac3920a.jpg";